import React from 'react';

import { IconType } from 'components/Icon/constants';
import { Title } from 'components/Toolbar/constants';
import Control from 'components/Toolbar/Controls/Control';
import { ControlState } from 'components/Toolbar/Controls/Control/constants';
import LinkDropdown from 'components/Toolbar/Dropdowns/Link';
import { useControlWithDropdown } from 'components/Toolbar/hooks';

import { LinkControlProps } from './models';

const LinkControl: React.FunctionComponent<LinkControlProps> = (props) => {
  const {
    isDisabled,
    link,
    toggleLink,
    className,
    enableInternalLinks = true,
    controlState = ControlState,
    returnFocusToEditor,
    priority,
    dataTestId = 'link',
  } = props;

  const { control, isOpen, state, toggleDropdown } = useControlWithDropdown({
    priority,
    controlState,
    closeDropdownCallback: returnFocusToEditor,
  });

  return (
    <Control
      className={className}
      controlState={controlState}
      disabled={isDisabled}
      onToggle={toggleDropdown}
      preventBlur={false}
      ref={control}
      size="sm-md"
      state={state}
      title={Title.LINK}
      type={IconType.LINK}
      dataTestId={`${dataTestId}-control`}
    >
      {isOpen && (
        <LinkDropdown
          link={link}
          toggleDropdown={(): void => {}}
          toggleLink={toggleLink}
          enableInternalLinks={enableInternalLinks}
          dataTestId={`${dataTestId}-dropdown`}
        />
      )}
    </Control>
  );
};

export default LinkControl;
